import { createContext } from "react";
const PlatformCtx = createContext({});
export default PlatformCtx;
